import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '@/module/Dashboard/Dashboard';
import { getProfileDetailsOptions } from '@/module/Dashboard/model/DashboardQuery';

export const Route = createFileRoute('/_auth/')({
  component: Index,
  staticData: {
    pageTitle: { id: 'pageTitle.dashboard' },
  },
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getProfileDetailsOptions());
  },
});

function Index() {
  const { data } = useSuspenseQuery(getProfileDetailsOptions());

  return <Dashboard profileDetails={data} />;
}
